import React, {useState, useEffect, useRef} from 'react';
import axios from 'axios';
import '../config.js';
import RichTextEditor from '../components/rte.js';
import { theme, createFormData } from '../services/helper.js';
import { alertService } from '../services/alert.service.js';
import Progress from '../components/progress.js';

function ReceiptBasicInfo(props){
  const [loading, setLoading] = useState(false);
  const [description, setDescription] = useState(props.receipt.description);
  const [amount, setAmount] = useState(props.receipt.amount);
  const [currency, setCurrency] = useState(props.receipt.currency);
  const [mode, setMode] = useState('Cash');
  const [notifySms, setNotifySms] = useState(0);
  const [notifyMail, setNotifyMail] = useState(0);
  
  const handleSubmit = (event) => {
    event.preventDefault();
    if(amount && description){
      setLoading(true);
      axios.post(global.config.api_server+'receipt',createFormData({
        description: description,
        amount: amount,
        currency: currency,
        token: localStorage.getItem("token"),
        id: props.id,
        mode: mode,
        invoice: props.receipt.invoice,
        task: 'edit',
        notifySms: notifySms,
        notifyMail: notifyMail
      })).then(res => {
        setLoading(false);
        if(res.status === 200 && res.data.status === "success"){
          alertService.success('Receipt updated');
        }else{
          alertService.error(res.data.error);
        }
      }).catch(err => {
        alertService.error(err);
        setLoading(false);
      });
    }else{
      alertService.error('Some fields are required');
    }
  }

  const handleNotifySms = (event) =>{
    if(event.target.checked){
      setNotifySms(1);
    }else{
      setNotifySms(0);
    }
  }

  const handleNotifyMail = (event) =>{
    if(event.target.checked){
      setNotifyMail(1);
    }else{
      setNotifyMail(0);
    }
  }

  return(
    <div className="card shadow mb-4">
      <div className="card-header py-3">     
        <button onClick={(e) => handleSubmit(e)} className={'btn btn-icon-split float-right btn-'+theme()}>
          <span className="icon text-white-50">
            <i className="fas fa-save"></i>
          </span>
          <span className="text">Save</span>
        </button>
        <h6 className={'mt-2 font-weight-bold text-'+theme()}>Receipt Detail</h6>
      </div>
      <div className="card-body">
        <div className="row">
          {loading === true ? (
            <Progress label='Saving' small={true}/>
          ):null}
          <div className="col-md-6">
            <div className="form-group">
              <label>Receipt id</label>
              <input type="text" value={props.receipt.receipt_id} disabled={true} className="form-control"/>
            </div>
            <div className="form-group">
              <label>Amount *</label>
              <input type="number" value={amount} maxLength="15" name="amount" className="form-control" id="amount" placeholder="Enter Amount" onChange={(e) => setAmount(e.target.value)}/>
            </div>
            <div className="form-group">
              <label>Mode of Payment</label>
              <select name="mode" className="form-control" id="mode" value={mode} onChange={(e) => setMode(e.target.value)}>
                <option value="Cash">Cash</option>
                <option value="Cheque">Cheque</option>
                <option value="Online">Online</option>
              </select>
            </div>
            <div className="form-group">
              <input type="checkbox" onChange={(e) => handleNotifyMail(e)}/> Send Mail &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<input type="checkbox" onChange={(e) => handleNotifySms(e)}/> Send SMS
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>Currency *</label>
              <select value={currency} name="currency" className="form-control" id="currency" onChange={(e) => setCurrency(e.target.value)}>
                {global.config.currencies.split(",").map(c =>
                  <option value={c} key={c}>{c}</option>
                )}
              </select>
            </div>
            <div className="form-group">
              <label>Description *</label>
              <textarea className="form-control textarea-xlg" value={description} onChange={(e)=>setDescription(e.target.value)}></textarea>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <hr/>
            <div className="form-group">
              <label><strong>Stats</strong></label>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>Updated</label>
              <input type="text" disabled={true} value={props.receipt.updation_date} className="form-control"/>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>Created</label>
              <input type="text" disabled={true} value={props.receipt.creation_date} className="form-control"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ReceiptBasicInfo;